import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Form } from "semantic-ui-react";
import { getTranslate } from "react-localize-redux";


class SearchProduct extends Component {

    constructor(props) {
        super(props);

        this.state = {
            code: ""
        };
    }

    render() {
        return (
            <Form onSubmit={() => {
                this.props.onSearch(this.state.code);
            }}>
                <Form.Input label='Artikelcode' value={this.state.codeOld}
                            onChange={(e) => {
                                this.setState({ code: e.target.value });
                            }}/>
                <Button type='submit'>Weiter</Button>
            </Form>
        );
    }
}

const mapStateToProps = state => ({
    translate: getTranslate(state.localize)
});


const mapDispatchToProps = (dispatch) => {
    return ({});
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SearchProduct);



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/ManageProducts/components/SearchProduct/index.js